// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-src_app_pages_pages_module_ts":"4440d657fe69653c","src_app_account_account_module_ts":"020cbc2941f29dab","src_app_pages_dashboards_dashboards_module_ts":"a30de65d02bad281"}[chunkId] + ".js";
};